import { Button, Layout } from "@mcleod/components";

export abstract class AutogenLayoutWireFundsProcessingToolPanel extends Layout {
    buttonUpdateStatuses: Button;
}
